<template>
    <v-layout>
        <v-navigation-drawer theme="dark" expand-on-hover rail absolute permanent id="main-nav">
            <v-list>
                <v-list-item v-if="user" :title="user.name"
                             :subtitle="user.email">
                    <template v-slot:prepend>
                        <avatar-small :object="user"></avatar-small>
                    </template>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list>
                <v-list-item v-for="item in menuItems"
                             :key="item.route"
                             :prepend-icon="item.icon"
                             variant="plain"
                             rounded="xl"
                             :to="item.route"
                             :title="item.title">
                </v-list-item>
                <v-list-item prepend-icon="mdi-logout"
                             variant="plain"
                             rounded="xl"
                             selectable
                             @click="logout"
                             title="Log out">
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar color="black">
            <v-avatar :tile="true" class="ml-4">
                <v-img src="/assets/logosmall.png"></v-img>
            </v-avatar>
            <template v-slot:append>
                <v-tooltip text="Day Timeline" location="bottom">
                    <template v-slot:activator="{ props }">
                        <div v-bind="props" class="timeline-progress-container mr-4" :class="{'expanded-btn-active': showTimeline}" @click="toggleViewTimeline">
                            <div class="d-flex align-center timeline-progress-row">
                                <span class="timeline-line-label">L1</span>
                                <line-progress-bar :progress="line1Progress"></line-progress-bar>
                                <span class="timeline-line-timer">{{ formatDuration(line1RunSeconds) }}</span>
                                <v-icon v-if="!lineIsRunning(timelineData.line1)" icon="mdi-pause-circle-outline" size="12" class="ms-1 flex-shrink-0"></v-icon>
                            </div>
                            <div class="d-flex align-center timeline-progress-row">
                                <span class="timeline-line-label">L2</span>
                                <line-progress-bar :progress="line2Progress"></line-progress-bar>
                                <span class="timeline-line-timer">{{ formatDuration(line2RunSeconds) }}</span>
                                <v-icon v-if="!lineIsRunning(timelineData.line2)" icon="mdi-pause-circle-outline" size="12" class="ms-1 flex-shrink-0"></v-icon>
                            </div>
                        </div>
                    </template>
                </v-tooltip>
                <nuwall-stock></nuwall-stock>
                <phone-recordings v-if="hasAdminAccess"></phone-recordings>
                <new-walls></new-walls>
                <import-line-validations></import-line-validations>
                <uncompleted-jobs></uncompleted-jobs>
                <v-tooltip text="Document Imports" location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn variant="plain" icon="mdi-file-document-arrow-right" v-bind="props" to="/documentimports">
                        </v-btn>
                    </template>
                </v-tooltip>
                <v-tooltip text="Budget Schedule" location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn variant="plain" icon="mdi-bullseye-arrow" v-bind="props" :class="{'expanded-btn' : showCalendar}" @click="toggleViewCalendar">
                        </v-btn>
                    </template>
                </v-tooltip>
                <search-bar></search-bar>
                <notifications-bar></notifications-bar>
            </template>
        </v-app-bar>
        <v-navigation-drawer permanent v-if="showSettingsMenu">
            <v-list rounded="lg">
                <v-list-item v-for="item in settingsMenuItems"
                             :key="item.route"
                             :prepend-icon="item.icon"
                             variant="plain"
                             :to="item.route"
                             :title="item.title">
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-main class="w-100">
            <div class="w-100 main-view">
                <div class="target-calendar" :class="{'expanded':showCalendar}">
                    <target-calendar :open-view="showCalendar"></target-calendar>
                </div>
                <div class="target-calendar timeline-calendar" :class="{'expanded':showTimeline}">
                    <day-timeline :open-view="showTimeline" :timeline-data="timelineData"></day-timeline>
                </div>
                <div class="pa-1">
                    <breadcrumb-bar></breadcrumb-bar>
                    <router-view />
                    <new-email-dialog></new-email-dialog>
                    <reschedule-job-dialog></reschedule-job-dialog>
                    <warehouse-add-dialog></warehouse-add-dialog>
                    <smart-job-rework-dialog></smart-job-rework-dialog>
                </div>
            </div>
            <history-footer v-if="showHistory"></history-footer>
        </v-main>
        <v-navigation-drawer :permanent="mdAndUp" v-if="showNotes" location="right" :expand-on-hover="!mdAndUp">
            <note-bar></note-bar>
        </v-navigation-drawer>
    </v-layout>
</template>
<style scoped>
    .v-input.expanding-search {
        transition: max-width 0.5s
    }
    .v-input__slot,.closed {
        max-width: 70px;
    }
    .main-view {
        min-height:700px;
    }
    .target-calendar {
        display: flex;
        background-color: white;
        transition: all 0.3s ease;
        height: 0px;
        border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
        overflow: hidden;
        background: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.25) 200%);
        color:white;
    }
    .target-calendar.expanded{
        height:200px;
    }
    .timeline-calendar.expanded {
        height:300px;
    }
    .close-btn {
        position:fixed;
        right:0px;
    }
    .expanded-btn {
        color: #1565C0 !important;
    }
    .timeline-progress-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 3px;
        cursor: pointer;
        padding: 4px 6px;
        border-radius: 8px;
        opacity: 0.7;
        width:200px;
        transition: opacity 0.2s;
    }
    .timeline-progress-container:hover {
        opacity: 1;
    }
    .timeline-progress-container.expanded-btn-active {
        opacity: 1;
        background: rgba(21, 101, 192, 0.2);
    }
    .timeline-progress-row {
        gap: 4px;
    }
    .timeline-line-label {
        font-size: 10px;
        color: white;
        width: 14px;
        flex-shrink: 0;
    }
    .timeline-line-timer {
        font-size: 10px;
        font-variant-numeric: tabular-nums;
        color: white;
        margin-left: 6px;
        flex-shrink: 0;
        white-space: nowrap;
    }
</style>
<script setup>
    import { useDisplay } from 'vuetify'

    const { mdAndUp } = useDisplay()
</script>
<script>
    import { mapActions, mapState, mapGetters } from "vuex";
    function initialState() {
        return {
            menuItems: [],
            settingsMenuItems: [],
            showCalendar: false,
            showTimeline: false,
            timelineData: {},
            nowTick: Date.now()
        };
    }
    export default {
        name: "AppLayout",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadTimelineData();
            this._timelineTimer = setInterval(() => this.loadTimelineData(), 5 * 60 * 1000);
            this._nowTimer = setInterval(() => { this.nowTick = Date.now(); }, 1000);
            this.menuItems = [
                {
                    icon: 'mdi-view-dashboard',
                    title: 'Dashboard',
                    route: '/'
                }
            ];
            if (this.hasSupportAccess) {
                this.menuItems.push({
                    icon: this.$constants.entities.Job.ICON,
                    title: this.$constants.entities.Job.PLURAL,
                    route: '/jobs'
                });
                this.menuItems.push({
                    icon: this.$constants.entities.Contact.ICON,
                    title: this.$constants.entities.Contact.PLURAL,
                    route: '/contacts'
                });
                this.menuItems.push({
                    icon: this.$constants.entities.Product.ICON,
                    title: this.$constants.entities.Product.PLURAL,
                    route: '/products'
                });
                this.menuItems.push({
                    icon: this.$constants.entities.Colour.ICON,
                    title: this.$constants.entities.Colour.PLURAL,
                    route: '/colours'
                });
                this.menuItems.push({
                    icon: this.$constants.entities.Staff.ICON,
                    title: this.$constants.entities.Staff.PLURAL,
                    route: '/staff'
                });
                this.menuItems.push({
                    icon: this.$constants.entities.Stock.ICON,
                    title: this.$constants.entities.Stock.PLURAL,
                    route: '/stock'
                });
            }
            this.menuItems.push({
                icon: 'mdi-file-chart',
                title: 'Reports',
                route: '/reports'
            });
            if (this.hasAdminAccess){

                this.menuItems.push({
                    icon: 'mdi-cog',
                    title: 'Settings',
                    route: '/settings'
                });
                this.settingsMenuItems = [
                    {
                        icon: 'mdi-web',
                        title: 'General',
                        route: '/settings/'
                    },
                    {
                        icon: this.$constants.entities.ApplicationUser.ICON,
                        title: this.$constants.entities.ApplicationUser.PLURAL,
                        route: '/settings/users'
                    },
                    {
                        icon: this.$constants.entities.ColourGroup.ICON,
                        title: this.$constants.entities.ColourGroup.PLURAL,
                        route: '/settings/colourgroups'
                    },
                    {
                        icon: this.$constants.entities.ContactGroup.ICON,
                        title: this.$constants.entities.ContactGroup.PLURAL,
                        route: '/settings/contactgroups'
                    },
                    {
                        icon: this.$constants.entities.MessageTemplate.ICON,
                        title: this.$constants.entities.MessageTemplate.PLURAL,
                        route: '/settings/messagetemplates'
                    },
                    {
                        icon: 'mdi-connection',
                        title: 'Xero',
                        route: '/settings/xero'
                    },
                    {
                        icon: 'mdi-connection',
                        title: 'Smartsheet',
                        route: '/settings/smartsheet'
                    }
                ];
            }
        },
        props: {
        },
        beforeUnmount() {
            clearInterval(this._timelineTimer);
            clearInterval(this._nowTimer);
        },
        methods: {
            ...mapActions([
                "logout",
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            loadTimelineData() {
                this.$api.get('/dashboard/timelineprogress')
                    .then(res => { this.timelineData = res.data; })
                    .catch(() => {});
            },
            lineProgress(lineSummary) {
                const lineData = lineSummary && lineSummary.timeline;
                if (!lineData) return 0;
                const completed = (lineData.totalLine || 0) + (lineData.totalColourChange || 0) + (lineData.totalBreak || 0);
                const total = completed + (lineData.totalEstimatedOutstanding || 0);
                return total === 0 ? 0 : (completed / total) * 100;
            },
            lineIsRunning(lineSummary) {
                return !!(lineSummary && lineSummary.isRunning);
            },
            lineRunSeconds(lineSummary) {
                if (!lineSummary) return 0;
                let seconds = (lineSummary.totalRunTimeHours || 0) * 3600;
                if (lineSummary.isRunning && lineSummary.runningSince) {
                    const elapsed = (this.nowTick - new Date(lineSummary.runningSince).getTime()) / 1000;
                    if (elapsed > 0) seconds += elapsed;
                }
                return seconds;
            },
            formatDuration(totalSeconds) {
                const s = Math.max(0, Math.floor(totalSeconds || 0));
                const h = Math.floor(s / 3600);
                const m = Math.floor((s % 3600) / 60);
                const sec = s % 60;
                return h > 0
                    ? `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
                    : `${m}:${String(sec).padStart(2, '0')}`;
            },
            toggleViewCalendar() {
                this.showCalendar = !this.showCalendar;
                this.showTimeline = false;
            },
            toggleViewTimeline() {
                this.showTimeline = !this.showTimeline;
                this.showCalendar = false;
            }
        },
        computed: {
            ...mapState({
                user: (state) => state.auth.user,
                entity: (state) => state.entities.entity
            }),
            ...mapGetters([
                'hasAdminAccess',
                'hasSupportAccess'
            ]),
            line1Progress() {
                return this.lineProgress(this.timelineData.line1);
            },
            line2Progress() {
                return this.lineProgress(this.timelineData.line2);
            },
            line1RunSeconds() {
                return this.lineRunSeconds(this.timelineData.line1);
            },
            line2RunSeconds() {
                return this.lineRunSeconds(this.timelineData.line2);
            },
            showSettingsMenu() {
                return this.hasAdminAccess && this.$route.name.startsWith('settings');
            },
            showNotes() {
                return this.$route.meta.showNotes === true;
            },
            showHistory() {
                return this.$route.meta.showHistory === true;
            }
        }
    };
</script>